import React from 'react';

import styles from './styles.module.scss';

const LinkExpired = () => (
  <div className={styles.quickpay}>
    <div className={styles.content}>
      <h1 className="mt-2 mb-4">For your security this link is no longer valid.</h1>
      <h1>
        Please call us at
        {' '}
        <a href="tel:+18885028082">(888) 502-8082</a>
        {' '}
        to get a new link.
      </h1>
    </div>
  </div>
);

export default LinkExpired;
